const fetchStudentComparison = async (url, abortController, token) => {
  abortController.current = new AbortController();
  const options = {
    signal: abortController.current.signal,
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      let errorResponse;
      try {
        errorResponse = await response.json();
      } catch {
        errorResponse = null;
      }
      const error = new Error(
        `Failed to fetch student comparison: ${JSON.stringify(errorResponse)} ${response.status}`
      );
      error.status = response.status;
      error.body = errorResponse;
      throw error;
    }
    return response.json();
  } catch (error) {
    const err = new Error("Error while fetching student comparison", {
      cause: error,
    });
    err.status = error.status;
    throw err;
  }
};

export default fetchStudentComparison;
